import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Text } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'

import { FullArticlePreview } from 'components/ui/Article/FullArticlePreview'
import { LimitedArticlePreview } from 'components/ui/Article/LimitedArticlePreview'
import { Button, ButtonText } from 'components/ui/Buttons/Button'
import { SectionCopy } from 'components/ui/Text/SectionCopy'
import { SectionHeading } from 'components/ui/Text/SectionHeading'

import { RelatedProjectsWrapper } from './styles'

type Props = {
  articles?: Article[] | null
}

export const RelatedProjectIdeas: React.FC<Props> = ({ articles }) => {
  const { t } = useTranslation('common')

  return (
    <Flex
      marginTop="36px"
      marginBottom={{ base: '40px', lg: 0 }}
      paddingY={{ lg: '85px' }}
      backgroundColor={{ lg: 'green.a50' }}
      width="100%"
    >
      <Flex
        width={{ base: 'calc(100% - 40px)', xl: '1320px' }}
        marginX="auto"
        direction={{ base: 'column', lg: 'row' }}
        justifyContent={{ lg: 'space-between' }}
      >
        <Flex
          marginTop="36px"
          justifyContent="space-between"
          alignItems="center"
          display={{ base: 'flex', lg: 'none' }}
        >
          <Text fontSize="sm">{t('relatedProjectIdeas')}</Text>
          <ButtonText href="/articles">{t('showAll')}</ButtonText>
        </Flex>

        <Flex display={{ base: 'none', lg: 'flex' }} direction="column" width="40%">
          <SectionHeading>{t('projectIdeas')}</SectionHeading>
          <Box marginTop="16px" marginBottom="30px">
            <SectionCopy>{t('projectIdeasCopy')}</SectionCopy>
          </Box>
          <Button href="/articles">{t('showAll')}</Button>
        </Flex>

        <Box display={{ lg: 'none' }}>
          <RelatedProjectsWrapper>
            {articles
              ?.filter((art) => Boolean(art))
              .map((article) => (
                <LimitedArticlePreview key={article.id} article={article} />
              ))}
          </RelatedProjectsWrapper>
        </Box>

        <Box display={{ base: 'none', lg: 'block' }} width="100%">
          <RelatedProjectsWrapper>
            {articles
              ?.filter((art) => Boolean(art))
              .map((article) => (
                <FullArticlePreview key={article.id} article={article} />
              ))}
          </RelatedProjectsWrapper>
        </Box>
      </Flex>
    </Flex>
  )
}
